import { fetcher } from "helpers/fetcher";

import { TGetEodReportListReq, TGetEodReportListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEodReportList = async (payload: TGetEodReportListReq) => {
  return fetcher<TGetEodReportListRes, TGetEodReportListReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_EOD_REPORT_LIST,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetEodReportList = async (payload: TGetEodReportListReq) => {
  return (await getEodReportList(payload)).data;
};

queryGetEodReportList._key = (payload: TGetEodReportListReq) => [
  ENDPOINT.MANAGEMENT.GET_EOD_REPORT_LIST.url,
  payload,
];
